var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "user-home-page dashboard-page",
      class: {
        "adjust-apps-container":
          _vm.isSuperAdmin === false && _vm.isSuperUser === false
      }
    },
    [
      _vm.isSuperAdmin || _vm.isSuperUser
        ? _c("header4IQ", { attrs: { fromapp: "ug" } })
        : _c("headerNew", {
            attrs: {
              fromapp: "ug",
              activeApp: _vm.activeApp,
              showEpalldashboard: _vm.showEpalldashboard,
              showMsspDashboard: _vm.showMsspDashboard
            },
            on: { switchApp: _vm.switchToApp }
          }),
      _vm._v(" "),
      _vm.showSnackbar
        ? _c("Snackbar", {
            attrs: {
              snackbarColor: _vm.snackbarColor,
              snackbarMessage: _vm.snackbarMessage
            },
            on: {
              close: function($event) {
                return _vm.closeSnackbar()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showModal
        ? _c("nextstepspopup", {
            attrs: { selectedapp: _vm.selectedapp },
            on: {
              close: function($event) {
                _vm.showModal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTnCView
        ? _c("app-terms", {
            attrs: { app: _vm.appNameForTnc, session: _vm.session }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AdvancedSearch", {
        attrs: { enablePopup: _vm.advancedSearchPopUp },
        on: {
          togglepopup: function(val) {
            return (_vm.advancedSearchPopUp = val)
          }
        }
      }),
      _vm._v(" "),
      !_vm.advancedSearchPopUp
        ? _c(
            "main",
            { staticClass: "main-container" },
            [
              _c(
                "section",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-lg": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "apps_and_users_tool_bar",
                              attrs: { xl12: "" }
                            },
                            [
                              _c(
                                "v-toolbar",
                                {
                                  staticStyle: { color: "indigo" },
                                  attrs: {
                                    dense: "",
                                    flat: "",
                                    color: "#EFEFEF"
                                  }
                                },
                                [
                                  _vm.isSuperAdmin || _vm.isSuperUser
                                    ? _c(
                                        "v-btn-toggle",
                                        {
                                          staticClass: "rounded-0",
                                          attrs: {
                                            borderless: "",
                                            mandatory: ""
                                          },
                                          model: {
                                            value: _vm.page,
                                            callback: function($$v) {
                                              _vm.page = $$v
                                            },
                                            expression: "page"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.isSuperAdmin ||
                                                    _vm.isSuperUser,
                                                  expression:
                                                    "isSuperAdmin || isSuperUser"
                                                }
                                              ],
                                              attrs: { value: "tenants" }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hidden-sm-and-down"
                                                },
                                                [_vm._v("Tenants")]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "app-button",
                                              attrs: { value: "apps" }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hidden-sm-and-down"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.tenantInfo
                                                        .app_label || "Apps"
                                                    ) +
                                                      " ( " +
                                                      _vm._s(
                                                        _vm.getAppsData.filter(
                                                          function(item) {
                                                            return _vm.enableAdvancedSearch
                                                              ? _vm.tenantSeperatedDetails[
                                                                  _vm
                                                                    .tenantInfo[
                                                                    "schema_name"
                                                                  ]
                                                                ].app_id.includes(
                                                                  item.pk
                                                                )
                                                              : true
                                                          }
                                                        ).length
                                                      ) +
                                                      " )"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.isTenantAdmin ||
                                                    _vm.isSuperAdmin ||
                                                    _vm.isSuperUser,
                                                  expression:
                                                    "isTenantAdmin || isSuperAdmin || isSuperUser"
                                                }
                                              ],
                                              attrs: { value: "users" }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hidden-sm-and-down"
                                                },
                                                [_vm._v("Users")]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !(_vm.isSuperAdmin || _vm.isSuperUser)
                                    ? _c("h4", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.tenantInfo.app_label || "Apps"
                                          ) +
                                            " ( " +
                                            _vm._s(_vm.getAppsData.length) +
                                            " )"
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            title: "Search",
                                            id: "enableAppsSearch"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.enableSearch = true
                                            }
                                          }
                                        },
                                        [_vm._v("search")]
                                      ),
                                      _vm._v(" "),
                                      _vm.enableSearch
                                        ? _c("v-text-field", {
                                            staticClass: "mt-4",
                                            attrs: {
                                              label: "Search",
                                              "append-icon": "clear",
                                              id: "closeAppsSearch",
                                              autofocus: ""
                                            },
                                            on: {
                                              "click:append": function($event) {
                                                return _vm.closeSearch()
                                              }
                                            },
                                            model: {
                                              value: _vm.searchText,
                                              callback: function($$v) {
                                                _vm.searchText = $$v
                                              },
                                              expression: "searchText"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isSuperAdmin,
                                          expression: "isSuperAdmin"
                                        }
                                      ],
                                      staticStyle: { display: "flex" }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            title: "Advanced Search",
                                            id: "enableSearch",
                                            color: _vm.enableAdvancedSearch
                                              ? "#e34d25 !important"
                                              : ""
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.advancedSearchPopUp = !_vm.advancedSearchPopUp
                                            }
                                          }
                                        },
                                        [_vm._v("zoom_in")]
                                      ),
                                      _vm._v(
                                        "    \n                            "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  (_vm.isSuperAdmin || _vm.isSuperUser) &&
                                  _vm.showMsspDashboard
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                dark: "",
                                                color: "#736B63",
                                                title:
                                                  _vm.tenantInfo.app_label +
                                                  " Dashboard"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.switchToApp({
                                                    name: "mssp-dashboard"
                                                  })
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "organization-dashboard",
                                                  attrs: {
                                                    color: "white",
                                                    dense: ""
                                                  }
                                                },
                                                [_vm._v("icon-dashboard")]
                                              ),
                                              _vm._v(
                                                " \n                                    " +
                                                  _vm._s(
                                                    _vm.tenantInfo.app_label ||
                                                      "Organizations"
                                                  ) +
                                                  "\n                                "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (_vm.isSuperAdmin || _vm.isSuperUser) &&
                                  _vm.showEpalldashboard
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                dark: "",
                                                color: "#736B63"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.switchToApp({
                                                    name:
                                                      "all-companies-dashboard"
                                                  })
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    All Companies Dashboard\n                                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isSuperAdmin || _vm.isSuperUser
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "label-temp" },
                                            [_vm._v(" Category:")]
                                          ),
                                          _vm._v(
                                            "   \n                                "
                                          ),
                                          _c("v-select", {
                                            staticClass: "temperature_select",
                                            attrs: {
                                              id: "categoryDropdown",
                                              items: _vm.categoryListDropdown
                                            },
                                            model: {
                                              value: _vm.categorySelected,
                                              callback: function($$v) {
                                                _vm.categorySelected = $$v
                                              },
                                              expression: "categorySelected"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isSuperAdmin || _vm.isSuperUser
                                    ? _c(
                                        "span",
                                        {
                                          attrs: { id: "includeDisabledApps" },
                                          on: {
                                            click: function($event) {
                                              _vm.disableApps = !_vm.disableApps
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.disableApps
                                                  ? "check_box"
                                                  : "check_box_outline_blank"
                                              )
                                            )
                                          ]),
                                          _vm._v(
                                            " \n                                "
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "includeDisabledApps",
                                              attrs: {
                                                title: "Include disabled apps"
                                              }
                                            },
                                            [_vm._v("Include disabled apps")]
                                          ),
                                          _vm._v(
                                            " \n                                "
                                          ),
                                          !_vm.disableApps
                                            ? _c("div", [
                                                _vm._v(
                                                  "( " +
                                                    _vm._s(
                                                      _vm.filterBy(
                                                        _vm.apps.filter(
                                                          function(item) {
                                                            return _vm.enableAdvancedSearch
                                                              ? _vm.tenantSeperatedDetails[
                                                                  _vm
                                                                    .tenantInfo[
                                                                    "schema_name"
                                                                  ]
                                                                ].app_id.includes(
                                                                  item.pk
                                                                )
                                                              : true
                                                          }
                                                        ),
                                                        _vm.searchText,
                                                        ["name"],
                                                        true,
                                                        {
                                                          category:
                                                            _vm.categorySelected
                                                        }
                                                      ).length -
                                                        _vm.getAppsData.filter(
                                                          function(item) {
                                                            return _vm.enableAdvancedSearch
                                                              ? _vm.tenantSeperatedDetails[
                                                                  _vm
                                                                    .tenantInfo[
                                                                    "schema_name"
                                                                  ]
                                                                ].app_id.includes(
                                                                  item.pk
                                                                )
                                                              : true
                                                          }
                                                        ).length
                                                    ) +
                                                    " )"
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isSuperAdmin || _vm.isSuperUser
                                    ? _c(
                                        "span",
                                        { attrs: { title: "Notes" } },
                                        [
                                          _c(
                                            "i",
                                            {
                                              staticClass: "material-icons",
                                              attrs: { id: "showNotes" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showNotesPopup()
                                                }
                                              }
                                            },
                                            [_vm._v("note")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isSuperAdmin &&
                                  !_vm.tenantInfo.disabled &&
                                  _vm.createIdtiUserEnable
                                    ? _c(
                                        "span",
                                        { attrs: { title: "Create App" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                dark: "",
                                                color: "#736B63"
                                              },
                                              on: {
                                                click: function($event) {
                                                  ;(_vm.idtiUserPopup = true),
                                                    (_vm.idtiUserName = "")
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    + Create IDTI User\n                                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (_vm.isSuperAdmin || _vm.isTenantAdmin) &&
                                  !_vm.tenantInfo.disabled
                                    ? _c(
                                        "span",
                                        {
                                          class: _vm.createIdtiUserEnable
                                            ? "disabled"
                                            : "enabled",
                                          attrs: { title: "Create App" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                dark: "",
                                                color: "#736B63"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.displayAppTypes()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    + NEW " +
                                                  _vm._s(
                                                    _vm.tenantInfo
                                                      .modified_app_label ||
                                                      _vm.modifyTenantInfo() ||
                                                      "App"
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("section", [
                _vm.selectType
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "on-clickaway",
                            rawName: "v-on-clickaway",
                            value: _vm.away,
                            expression: "away"
                          }
                        ],
                        staticClass: "select_app_types_list"
                      },
                      [
                        _vm.availableTypes.length > 0
                          ? _c(
                              "v-list",
                              { attrs: { dense: "", subheader: "" } },
                              [
                                _c(
                                  "v-toolbar",
                                  {
                                    attrs: {
                                      color: "#736B63",
                                      dark: "",
                                      dense: ""
                                    }
                                  },
                                  [
                                    _c("v-toolbar-title", [
                                      _vm._v("Select app type")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.availableTypes, function(eachApp) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: eachApp.display_name,
                                      staticClass:
                                        "each_app_type_in_list_of_apps",
                                      on: {
                                        click: function($event) {
                                          return _vm.newApp(
                                            _vm.availableTypes,
                                            eachApp.display_name,
                                            eachApp.name
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "icon_for_apps" },
                                            [_vm._v("brightness_auto")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", {
                                            domProps: {
                                              textContent: _vm._s(
                                                eachApp.display_name
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          : _c(
                              "v-list",
                              [
                                _c(
                                  "v-toolbar",
                                  {
                                    attrs: {
                                      color: "#F54B5E",
                                      dark: "",
                                      dense: ""
                                    }
                                  },
                                  [
                                    _c("v-toolbar-title", [
                                      _vm._v("No Apps selected")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", "justify-center": "" } },
                    [
                      _c(
                        "v-dialog",
                        {
                          attrs: { persistent: "", "max-width": "600px" },
                          model: {
                            value: _vm.idtiUserPopup,
                            callback: function($$v) {
                              _vm.idtiUserPopup = $$v
                            },
                            expression: "idtiUserPopup"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-title", [
                                _c("span", { staticClass: "headline" }, [
                                  _vm._v("IDTI User")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { "grid-list-md": "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "User*",
                                                  required: ""
                                                },
                                                model: {
                                                  value: _vm.idtiUserName,
                                                  callback: function($$v) {
                                                    _vm.idtiUserName = $$v
                                                  },
                                                  expression: "idtiUserName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                [
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      on: {
                                        click: function($event) {
                                          ;(_vm.idtiUserPopup = false),
                                            (_vm.idtiUserName = "")
                                        }
                                      }
                                    },
                                    [_vm._v("Close")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.createNewIDTIUser()
                                        }
                                      }
                                    },
                                    [_vm._v("Save")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "apps mt-3" },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-lg": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _vm._l(
                            _vm.getAppsData.filter(function(item) {
                              return _vm.enableAdvancedSearch
                                ? _vm.tenantSeperatedDetails[
                                    _vm.tenantInfo["schema_name"]
                                  ].app_id.includes(item.pk)
                                : true
                            }),
                            function(app, index) {
                              return _c(
                                "v-flex",
                                {
                                  key: index,
                                  staticClass: "apps_page",
                                  attrs: { lg3: "" }
                                },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "apps_enable_disable",
                                      class: app.disabled
                                        ? "disable"
                                        : "enable",
                                      attrs: { id: "appsCard" }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          staticClass: "apps-card",
                                          attrs: { row: "", wrap: "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "apps_company-logo",
                                              attrs: {
                                                xs4: "",
                                                "overflow-hidden": ""
                                              }
                                            },
                                            [
                                              app["service"]["name"] == "ep"
                                                ? _c("div", {
                                                    staticClass: "ep-name-logo"
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass: "name-logo"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("logoName")(
                                                            app["service"][
                                                              "display_name"
                                                            ]
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          app["service"]["name"] == "ep"
                                            ? _c(
                                                "v-flex",
                                                {
                                                  staticClass:
                                                    "apps_company-info",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "apps_comapny-title",
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticStyle: {
                                                            display: "flex"
                                                          },
                                                          attrs: { xs10: "" }
                                                        },
                                                        [
                                                          index ==
                                                          _vm.editableIndex
                                                            ? _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "apps_company-service text-field",
                                                                  model: {
                                                                    value:
                                                                      app.name,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        app,
                                                                        "name",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "app.name"
                                                                  }
                                                                }
                                                              )
                                                            : _c("span", {
                                                                staticClass:
                                                                  "apps_company-service",
                                                                attrs: {
                                                                  title:
                                                                    app.name
                                                                },
                                                                domProps: {
                                                                  textContent: _vm._s(
                                                                    app.name
                                                                  )
                                                                }
                                                              })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs1: "" } },
                                                        [
                                                          !_vm.isSuperUser &&
                                                          !app.ug_role.includes(
                                                            "User"
                                                          ) &&
                                                          !app.ug_role.includes(
                                                            "tenantAdmin"
                                                          )
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      staticClass:
                                                                        "app_settings_icon ma-0",
                                                                      attrs: {
                                                                        icon:
                                                                          "",
                                                                        left:
                                                                          "",
                                                                        small:
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.settingsIndex ==
                                                                          app[
                                                                            "pk"
                                                                          ]
                                                                            ? _vm.closeSettings()
                                                                            : _vm.openSettings(
                                                                                app[
                                                                                  "service_details"
                                                                                ][
                                                                                  "app_token"
                                                                                ],
                                                                                index,
                                                                                app[
                                                                                  "service"
                                                                                ][
                                                                                  "name"
                                                                                ],
                                                                                app
                                                                              )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "grey darken-1"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                        " +
                                                                              _vm._s(
                                                                                _vm.settingsIndex ==
                                                                                  app[
                                                                                    "pk"
                                                                                  ]
                                                                                  ? "close"
                                                                                  : "settings"
                                                                              ) +
                                                                              "\n                                                    "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "apps_card-subcontent",
                                                      class:
                                                        !app.disabled &&
                                                        app.service.callback &&
                                                        (app["service_details"][
                                                          "node"
                                                        ] != "Germany" ||
                                                          app.service.name ==
                                                            "id_monitoring_with_leadgen" ||
                                                            app.service.name ==
                                                              "id_monitoring" ||
                                                            app.service.name ==
                                                              "id_monitoring_lite")
                                                          ? ""
                                                          : "disabled",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.switchApp(
                                                            app,
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          staticClass:
                                                            "company-sub-elements",
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "apps_company-subtitle",
                                                              attrs: { xs6: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  attrs: {
                                                                    title:
                                                                      "Domains"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Domains"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "apps_company-domins-count",
                                                              attrs: { xs6: "" }
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    app[
                                                                      "epd_app_status"
                                                                    ][
                                                                      "domains_count"
                                                                    ]
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          staticClass:
                                                            "company-sub-elements",
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "apps_company-subtitle top-padding",
                                                              attrs: { xs6: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "alerts_icon"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "notifications_none"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "apps_company-alerts-count top-padding",
                                                              attrs: { xs6: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "count"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      app[
                                                                        "epd_app_status"
                                                                      ][
                                                                        "alerts_count"
                                                                      ]
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          staticClass:
                                                            "company-sub-elements",
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "apps_company-tenant-name top-padding",
                                                              attrs: {
                                                                xs12: ""
                                                              }
                                                            },
                                                            [
                                                              _vm.isSuperAdmin
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "4IQ Admin"
                                                                    )
                                                                  ])
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          staticClass:
                                                            "company-sub-elements",
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "apps_company-date",
                                                              attrs: { xs1: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "time_icon"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "access_time"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "apps_company-date",
                                                              attrs: { xs6: "" }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "date"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      app[
                                                                        "date"
                                                                      ]
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _c(
                                                "v-flex",
                                                {
                                                  staticClass:
                                                    "apps_company-info",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticStyle: {
                                                            display: "flex"
                                                          },
                                                          attrs: { xs12: "" }
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "apps_company-service",
                                                            attrs: {
                                                              title:
                                                                app.service
                                                                  .display_name
                                                            },
                                                            domProps: {
                                                              textContent: _vm._s(
                                                                app.service
                                                                  .display_name
                                                              )
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("v-spacer"),
                                                          _vm._v(" "),
                                                          !_vm.isSuperUser &&
                                                          !app.ug_role.includes(
                                                            "User"
                                                          )
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      staticClass:
                                                                        "app_settings_icon ma-0",
                                                                      attrs: {
                                                                        icon:
                                                                          "",
                                                                        left:
                                                                          "",
                                                                        small:
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.settingsIndex ==
                                                                          app[
                                                                            "pk"
                                                                          ]
                                                                            ? _vm.closeSettings()
                                                                            : _vm.openSettings(
                                                                                app[
                                                                                  "service_details"
                                                                                ][
                                                                                  "app_token"
                                                                                ],
                                                                                index,
                                                                                app[
                                                                                  "service"
                                                                                ][
                                                                                  "name"
                                                                                ],
                                                                                app
                                                                              )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "grey darken-1"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                        " +
                                                                              _vm._s(
                                                                                _vm.settingsIndex ==
                                                                                  app[
                                                                                    "pk"
                                                                                  ]
                                                                                  ? "close"
                                                                                  : "settings"
                                                                              ) +
                                                                              "\n                                                    "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "company-sub-elements",
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-subtitle",
                                                          attrs: { xs2: "" }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "user_icon"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "person_outline"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-domins-count",
                                                          attrs: { xs9: "" }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "app-username",
                                                              attrs: {
                                                                title:
                                                                  app
                                                                    .service_details
                                                                    .username
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  app
                                                                    .service_details
                                                                    .username
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "company-sub-elements",
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-subtitle top-padding",
                                                          attrs: { xs2: "" }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("flag")
                                                          ])
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-alerts-count top-padding",
                                                          attrs: { xs6: "" }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                title:
                                                                  app[
                                                                    "service_details"
                                                                  ]["node"]
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  app[
                                                                    "service_details"
                                                                  ]["node"]
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "company-sub-elements",
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-tenant-name top-padding",
                                                          attrs: { xs12: "" }
                                                        },
                                                        [
                                                          _vm.isSuperAdmin
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "4IQ Admin"
                                                                )
                                                              ])
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "company-sub-elements",
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-date",
                                                          attrs: { xs1: "" }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "time_icon"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "access_time"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-date",
                                                          attrs: { xs6: "" }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "date"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  app["date"]
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider", {
                                        staticClass: "#8C857E"
                                      }),
                                      _vm._v(" "),
                                      app["service"]["name"] == "ep"
                                        ? _c(
                                            "v-card-actions",
                                            [
                                              index == _vm.editableIndex
                                                ? _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "app-card-actions",
                                                          staticStyle: {
                                                            display: "flex"
                                                          },
                                                          attrs: { xs12: "" }
                                                        },
                                                        [
                                                          _c("v-spacer"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "mr-2",
                                                              attrs: {
                                                                depressed: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.cancelEdit()
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                            Cancel\n                                        "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                depressed: "",
                                                                color:
                                                                  "#8C857E",
                                                                dark: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.updateApptoken(
                                                                    app
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                            Save\n                                        "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "app-card-actions customized",
                                                          staticStyle: {
                                                            display: "flex"
                                                          },
                                                          attrs: { xs12: "" }
                                                        },
                                                        [
                                                          !app.disabled
                                                            ? _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    icon: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.editAppDetails(
                                                                        app,
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  !_vm.isSuperUser
                                                                    ? _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "edit_icon"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "icon-edit"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          !app.disabled
                                                            ? _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    icon: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.confimationAction(
                                                                        app
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  !_vm.isSuperUser
                                                                    ? _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "delete_icon"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "icon-delete"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("v-spacer"),
                                                          _vm._v(" "),
                                                          app.disabled
                                                            ? _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    depressed:
                                                                      "",
                                                                    color:
                                                                      "#8C857E",
                                                                    dark: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.enableDisableApp(
                                                                        "enable",
                                                                        app
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                            Enable\n                                        "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-card-actions",
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticStyle: {
                                                        display: "flex"
                                                      },
                                                      attrs: { xs12: "" }
                                                    },
                                                    [
                                                      _c("h3", {
                                                        staticClass:
                                                          "apps_company-name",
                                                        attrs: {
                                                          title: app.name
                                                        },
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            app.name
                                                          )
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-spacer"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          class:
                                                            !app.disabled &&
                                                            !_vm.isExpired(
                                                              app.expiration_date
                                                            ) &&
                                                            app.service
                                                              .callback &&
                                                            (app[
                                                              "service_details"
                                                            ]["node"] !=
                                                              "Germany" ||
                                                              app.service
                                                                .name ==
                                                                "id_monitoring_with_leadgen" ||
                                                                app.service
                                                                  .name ==
                                                                  "id_monitoring" ||
                                                                app.service
                                                                  .name ==
                                                                  "id_monitoring_lite")
                                                              ? ""
                                                              : "disabled"
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "enable_B",
                                                              attrs: {
                                                                icon: "",
                                                                id: "launchApp",
                                                                disabled: _vm.isExpired(
                                                                  app.expiration_date
                                                                ),
                                                                title: _vm.isExpired(
                                                                  app.expiration_date
                                                                )
                                                                  ? "App is expired"
                                                                  : "Launch"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  !_vm.isExpired(
                                                                    app.expiration_date
                                                                  ) &&
                                                                    _vm.switchApp(
                                                                      app,
                                                                      index
                                                                    )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              !app.disabled &&
                                                              app.service
                                                                .callback
                                                                ? _c("v-icon", [
                                                                    _vm._v(
                                                                      "open_in_new"
                                                                    )
                                                                  ])
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      !_vm.isSuperUser &&
                                                      !app["disabled"] &&
                                                      !app.ug_role.includes(
                                                        "User"
                                                      ) &&
                                                      !app.ug_role.includes(
                                                        "tenantAdmin"
                                                      ) &&
                                                      !app.ug_role.includes(
                                                        "appAdmin"
                                                      )
                                                        ? _c(
                                                            "v-menu",
                                                            {
                                                              attrs: {
                                                                transition:
                                                                  "scale-transition",
                                                                "offset-x": "",
                                                                right: ""
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "activator",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var on =
                                                                        ref.on
                                                                      return [
                                                                        _c(
                                                                          "v-btn",
                                                                          _vm._g(
                                                                            {
                                                                              attrs: {
                                                                                slot:
                                                                                  "activator",
                                                                                icon:
                                                                                  "",
                                                                                id:
                                                                                  "openAppMenuBtn"
                                                                              },
                                                                              slot:
                                                                                "activator"
                                                                            },
                                                                            on
                                                                          ),
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "more_vert"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            },
                                                            [
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-list",
                                                                [
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.showEditApptokenPopup(
                                                                            app
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        [
                                                                          _vm._v(
                                                                            "Edit"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      class: app.jira_ticket
                                                                        ? ""
                                                                        : "disabled"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        [
                                                                          _c(
                                                                            "a",
                                                                            {
                                                                              staticClass:
                                                                                "cmpny_links",
                                                                              attrs: {
                                                                                target:
                                                                                  "new",
                                                                                href:
                                                                                  app.jira_ticket
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Open JIRA"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-divider"
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.openSettings(
                                                                            app[
                                                                              "service_details"
                                                                            ][
                                                                              "app_token"
                                                                            ],
                                                                            index,
                                                                            app[
                                                                              "service"
                                                                            ][
                                                                              "name"
                                                                            ],
                                                                            app
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        [
                                                                          _vm._v(
                                                                            "Settings"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      staticStyle: {
                                                                        cursor:
                                                                          "pointer"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        [
                                                                          _vm._v(
                                                                            "Close"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.isSuperAdmin &&
                                                      !_vm.tenantInfo.disabled
                                                        ? _c(
                                                            "span",
                                                            [
                                                              app.disabled
                                                                ? _c(
                                                                    "v-btn",
                                                                    {
                                                                      staticClass:
                                                                        "mt-1",
                                                                      attrs: {
                                                                        depressed:
                                                                          "",
                                                                        color:
                                                                          "#8C857E",
                                                                        dark: ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.enableDisableApp(
                                                                            "enable",
                                                                            app
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                enable\n                                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          _vm.showNewApp
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "apps_page",
                                  attrs: { lg3: "" }
                                },
                                [
                                  _vm.showNewApp
                                    ? _c(
                                        "v-card",
                                        {
                                          staticClass: "apps_enable_disable",
                                          attrs: { id: "appsCard" }
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              staticClass: "apps-card",
                                              attrs: { row: "", wrap: "" }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass:
                                                    "apps_company-logo",
                                                  attrs: {
                                                    xs4: "",
                                                    "overflow-hidden": ""
                                                  }
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "name-logo"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass:
                                                    "apps_company-info",
                                                  attrs: { xs8: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "apps_comapny-title",
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticStyle: {
                                                            display: "flex"
                                                          },
                                                          attrs: { xs12: "" }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "apps_company-service text-field pt-1",
                                                            attrs: {
                                                              label: "Name",
                                                              color: "#8C857E"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .newAppCreationDetails
                                                                  .appName,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.newAppCreationDetails,
                                                                  "appName",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "newAppCreationDetails.appName"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "company-sub-elements",
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-subtitle top-padding",
                                                          attrs: { xs4: "" }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                title: "Domains"
                                                              }
                                                            },
                                                            [_vm._v("Domains")]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-domins-count top-padding",
                                                          attrs: { xs6: "" }
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .newAppCreationDetails[
                                                                  "domains_count"
                                                                ] || "-"
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "company-sub-elements",
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-subtitle top-padding",
                                                          attrs: { xs4: "" }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "alerts_icon"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "notifications_none"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-alerts-count top-padding",
                                                          attrs: { xs6: "" }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "count"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .newAppCreationDetails[
                                                                    "alerts_count"
                                                                  ] || "-"
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "company-sub-elements",
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-tenant-name top-padding",
                                                          attrs: { xs12: "" }
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v("4IQ Admin")
                                                          ])
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "company-sub-elements",
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-date",
                                                          attrs: { xs1: "" }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "time_icon"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "access_time"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass:
                                                            "apps_company-date",
                                                          attrs: { xs6: "" }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "date"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .newAppCreationDetails[
                                                                    "date"
                                                                  ] ||
                                                                    _vm.defaultDate
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-divider", {
                                            staticClass: "#8C857E"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-actions",
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "app-card-actions",
                                                      staticStyle: {
                                                        display: "flex"
                                                      },
                                                      attrs: { xs12: "" }
                                                    },
                                                    [
                                                      _c("v-spacer"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            depressed: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.cancelAppCreation()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            Cancel\n                                        "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            depressed: "",
                                                            color: "#8C857E",
                                                            dark: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.addNewApp()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            Save\n                                        "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "v-dialog",
                    {
                      staticClass: "show-info-popup",
                      attrs: {
                        width: "60rem",
                        id: "appCreationPopup",
                        persistent: ""
                      },
                      model: {
                        value: _vm.appCreationPopup,
                        callback: function($$v) {
                          _vm.appCreationPopup = $$v
                        },
                        expression: "appCreationPopup"
                      }
                    },
                    [
                      _c("v-card", { staticClass: "popup-card" }, [
                        _c(
                          "div",
                          { staticClass: "user_creation_popup_div" },
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "pa-2 ma-2",
                                    attrs: { xs1: "" }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { staticClass: "apps_creation_logo" },
                                      [
                                        _vm._v(
                                          "\n                                    brightness_auto\n                                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "pa-1 ma-2 mt-4 pt-3",
                                    attrs: { xs9: "" }
                                  },
                                  [
                                    _c("h3", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.storeSelectedType
                                        )
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pt-3 ma-2 pl-2",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    App Name *\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            id: "appName",
                                            label: "App Name"
                                          },
                                          model: {
                                            value: _vm.newapp.name,
                                            callback: function($$v) {
                                              _vm.$set(_vm.newapp, "name", $$v)
                                            },
                                            expression: "newapp.name"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pt-3 ma-2 pl-2",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Description\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            id: "appDescription",
                                            label: "Description"
                                          },
                                          model: {
                                            value: _vm.newapp.custom_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newapp,
                                                "custom_name",
                                                $$v
                                              )
                                            },
                                            expression: "newapp.custom_name"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pt-3 ma-2 pl-2",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "\n                                        Data center *\n                                    "
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "" } },
                                      [
                                        _vm.editApptoken
                                          ? _c("v-text-field", {
                                              attrs: {
                                                id: "dataCenter",
                                                label: "Data Center",
                                                readonly: ""
                                              },
                                              model: {
                                                value:
                                                  _vm.newapp.selectedDataCenter,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newapp,
                                                    "selectedDataCenter",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newapp.selectedDataCenter"
                                              }
                                            })
                                          : _c("v-select", {
                                              attrs: {
                                                items: _vm.dataCentersList,
                                                id: "dataCentreDropdown",
                                                label: "Data center"
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.getIdtiUsers()
                                                }
                                              },
                                              model: {
                                                value: _vm.selectedDataCenter,
                                                callback: function($$v) {
                                                  _vm.selectedDataCenter = $$v
                                                },
                                                expression: "selectedDataCenter"
                                              }
                                            })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.emptyIdtiUser && !_vm.editApptoken
                                  ? _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass:
                                              "pa-2 ma-2 existingIdtiUser_class",
                                            attrs: { xs3: "" }
                                          },
                                          [
                                            _c(
                                              "v-radio-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.selectUserCreationType,
                                                  callback: function($$v) {
                                                    _vm.selectUserCreationType = $$v
                                                  },
                                                  expression:
                                                    "selectUserCreationType"
                                                }
                                              },
                                              [
                                                _c("v-radio", {
                                                  attrs: {
                                                    id:
                                                      "useExistingUserRadioBtn",
                                                    label:
                                                      "Use existing IDTI users *",
                                                    value: "false"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.userCreation(
                                                        "false"
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs8: "" } },
                                          [
                                            _c("v-select", {
                                              class:
                                                _vm.selectUserCreationType ==
                                                "false"
                                                  ? "enable"
                                                  : "disabled",
                                              attrs: {
                                                id: "existingIdtiUsersDropdown",
                                                items:
                                                  _vm.existingIdtiUsersList,
                                                label:
                                                  "Use existing IDTI users",
                                                tabindex:
                                                  _vm.selectUserCreationType ==
                                                  "false"
                                                    ? ""
                                                    : "-1"
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.existingIdtiUser(
                                                    "false"
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.existingUserIDTI,
                                                callback: function($$v) {
                                                  _vm.existingUserIDTI = $$v
                                                },
                                                expression: "existingUserIDTI"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        class: _vm.editApptoken
                                          ? "pt-3 ma-2 pl-2"
                                          : "ml-3",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _vm.editApptoken
                                          ? _c("span", [
                                              _vm._v("IDTI User Name*")
                                            ])
                                          : _c(
                                              "v-radio-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.selectUserCreationType,
                                                  callback: function($$v) {
                                                    _vm.selectUserCreationType = $$v
                                                  },
                                                  expression:
                                                    "selectUserCreationType"
                                                }
                                              },
                                              [
                                                _c("v-radio", {
                                                  attrs: {
                                                    id: "useNewUserRadioBtn",
                                                    label:
                                                      "Create a new user *",
                                                    value: "true"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.userCreation(
                                                        "true"
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "" } },
                                      [
                                        _c("v-text-field", {
                                          class:
                                            _vm.selectUserCreationType == "true"
                                              ? "enable"
                                              : "disabled",
                                          attrs: {
                                            id: "newIDTIUserName",
                                            label: "IDTI User name",
                                            readonly: _vm.editApptoken,
                                            tabindex:
                                              _vm.selectUserCreationType ==
                                              "true"
                                                ? ""
                                                : "-1"
                                          },
                                          model: {
                                            value: _vm.newapp.user_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newapp,
                                                "user_name",
                                                $$v
                                              )
                                            },
                                            expression: "newapp.user_name"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pt-3 ma-2 pl-2",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Category *\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "" } },
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.appCategoryListDropdown,
                                            id: "appCategoryDropdown",
                                            label: "Category"
                                          },
                                          model: {
                                            value: _vm.newapp.category,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newapp,
                                                "category",
                                                $$v
                                              )
                                            },
                                            expression: "newapp.category"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pt-3 ma-2 pl-2",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Jira Ticket\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "" } },
                                      [
                                        _c(
                                          "v-text-field",
                                          {
                                            attrs: {
                                              id: "jiraTicket",
                                              label: "JIRA Ticket",
                                              rules: _vm.ticketValidate
                                            },
                                            model: {
                                              value: _vm.newapp.jiraTicket,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newapp,
                                                  "jiraTicket",
                                                  $$v
                                                )
                                              },
                                              expression: "newapp.jiraTicket"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    >"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "pt-3 ma-2 pl-2",
                                        attrs: { xs3: "" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Expiration Date\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "" } },
                                      [
                                        _c(
                                          "v-menu",
                                          {
                                            ref: "calenderMenu",
                                            staticClass: "calendar-menu",
                                            attrs: {
                                              "close-on-content-click": false,
                                              "return-value":
                                                _vm.newapp.expirationDate,
                                              transition: "scale-transition",
                                              "offset-y": "",
                                              "max-width": "290px",
                                              "min-width": "290px"
                                            },
                                            on: {
                                              "update:returnValue": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.newapp,
                                                  "expirationDate",
                                                  $event
                                                )
                                              },
                                              "update:return-value": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.newapp,
                                                  "expirationDate",
                                                  $event
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "v-text-field",
                                                        _vm._g(
                                                          {
                                                            attrs: {
                                                              slot: "activator",
                                                              label:
                                                                "Expiration Date",
                                                              readonly: "",
                                                              clearable: ""
                                                            },
                                                            slot: "activator",
                                                            model: {
                                                              value:
                                                                _vm.newapp
                                                                  .expirationDate,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.newapp,
                                                                  "expirationDate",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "newapp.expirationDate"
                                                            }
                                                          },
                                                          on
                                                        )
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              3670112907
                                            ),
                                            model: {
                                              value: _vm.calenderMenu,
                                              callback: function($$v) {
                                                _vm.calenderMenu = $$v
                                              },
                                              expression: "calenderMenu"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "v-date-picker",
                                              {
                                                attrs: {
                                                  scrollable: "",
                                                  min: _vm.minDateInPicker
                                                },
                                                model: {
                                                  value:
                                                    _vm.newapp.expirationDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newapp,
                                                      "expirationDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newapp.expirationDate"
                                                }
                                              },
                                              [
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      text: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.calenderMenu = false
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      text: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.$refs.calenderMenu.save(
                                                          _vm.newapp
                                                            .expirationDate
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("OK")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass:
                                      "pa-2 ma-2 save_in_app_creation",
                                    attrs: { xs12: "" }
                                  },
                                  [
                                    _c("v-spacer"),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class: _vm.disableActionBtn
                                          ? "disabled"
                                          : ""
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "ma-2",
                                            class:
                                              _vm.newapp.name &&
                                              (_vm.newapp.user_name ||
                                                _vm.userNameFlag) &&
                                              _vm.newapp.category
                                                ? "enable"
                                                : "disabled",
                                            attrs: {
                                              id: "saveAppBtn",
                                              depressed: "",
                                              color: "grey lighten-3"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.editApptoken
                                                  ? _vm.updateApptoken()
                                                  : _vm.addNewApp()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    save\n                                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-2",
                                        attrs: {
                                          id: "cancelCreatingAppBtn",
                                          depressed: "",
                                          color: "grey lighten-3"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteApp()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    cancel \n                                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.appSettings && _vm.availableAppToken
                ? _c(
                    "v-container",
                    {
                      staticClass: "settings_pannel",
                      attrs: { fluid: "", "pa-0": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        [
                          _c("v-card", { staticClass: "apptoken-title" }, [
                            _c("span", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(_vm.selectedApp.name) +
                                  "\n                        "
                              ),
                              _vm.selectedApp.category
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s("- " + _vm.selectedApp.category)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedApp["type"] == "ida"
                                ? _c(
                                    "fieldset",
                                    { staticClass: "mt-4" },
                                    [
                                      _c("legend", [
                                        _vm._v("Search Sources Config Panel")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "hunt-data-sources" },
                                        _vm._l(_vm.huntdatasources, function(
                                          dataSource
                                        ) {
                                          return _c("v-checkbox", {
                                            key: dataSource["id"],
                                            staticClass: "tnccheckbox",
                                            attrs: { label: dataSource.value },
                                            on: {
                                              change: function($event) {
                                                return _vm.updateDataSource(
                                                  dataSource,
                                                  _vm.selectedApp["type"]
                                                )
                                              }
                                            },
                                            model: {
                                              value: dataSource["status"],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  dataSource,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "dataSource['status']"
                                            }
                                          })
                                        }),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "hunt-data-sources" },
                                        [
                                          _c("v-checkbox", {
                                            staticClass:
                                              "tnccheckbox hunt-data-sources",
                                            attrs: {
                                              label: "View Full Password"
                                            },
                                            on: {
                                              change: _vm.setViewFullPassword
                                            },
                                            model: {
                                              value:
                                                _vm.selectedApp[
                                                  "full_password"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.selectedApp,
                                                  "full_password",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "selectedApp['full_password']"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-checkbox", {
                                            staticClass:
                                              "tnccheckbox hunt-data-sources",
                                            attrs: {
                                              label: "Shared Investigation"
                                            },
                                            on: {
                                              change: _vm.setSharedInvestigation
                                            },
                                            model: {
                                              value:
                                                _vm.selectedApp[
                                                  "shared_investigation"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.selectedApp,
                                                  "shared_investigation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "selectedApp['shared_investigation']"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-checkbox", {
                                            staticClass:
                                              "tnccheckbox hunt-data-sources",
                                            attrs: {
                                              label: "Enable DataBrokers"
                                            },
                                            on: {
                                              change: _vm.setEnableDataBrokers
                                            },
                                            model: {
                                              value:
                                                _vm.selectedApp[
                                                  "enable_dataBrokers"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.selectedApp,
                                                  "enable_dataBrokers",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "selectedApp['enable_dataBrokers']"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedApp["type"] == "ep"
                                ? _c(
                                    "span",
                                    [
                                      _c("legend", { staticClass: "pt-3" }, [
                                        _vm._v("Licences")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-autocomplete", {
                                        staticClass: "pt-3",
                                        attrs: {
                                          items: _vm.domeLicencesList,
                                          chips: "",
                                          "search-input": _vm.searchInput,
                                          multiple: "",
                                          outlined: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.searchInput = null
                                          },
                                          "update:searchInput": function(
                                            $event
                                          ) {
                                            _vm.searchInput = $event
                                          },
                                          "update:search-input": function(
                                            $event
                                          ) {
                                            _vm.searchInput = $event
                                          },
                                          change: function($event) {
                                            return _vm.updateLicences(
                                              _vm.domeEnabledLicences,
                                              _vm.selectedApp["type"]
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.domeEnabledLicences,
                                          callback: function($$v) {
                                            _vm.domeEnabledLicences = $$v
                                          },
                                          expression: "domeEnabledLicences"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          staticClass: "settings-flex-componant",
                          attrs: { wrap: "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("ipwhitelist", {
                                attrs: {
                                  id: "ipWhiteListComponent",
                                  apptoken: _vm.app_token,
                                  nodeValue: _vm.nodeValueForApp
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("tokens", {
                                attrs: {
                                  id: "tokensComponent",
                                  apptoken: _vm.app_token,
                                  userName: _vm.userName,
                                  userToken: _vm.userToken,
                                  appid: _vm.selectedappid,
                                  nodeValue: _vm.nodeValueForApp
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md4: "" } },
                            [
                              _c("bar-line-chart", {
                                attrs: {
                                  id: "barlineChartComponent",
                                  apptoken: _vm.app_token,
                                  isalertchart: _vm.isalertchart,
                                  nodeValue: _vm.nodeValueForApp
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { staticClass: "settings-flex-componant" },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "ma-1",
                              attrs: { sm12: "", md6: "" }
                            },
                            [
                              _c("configuration", {
                                attrs: {
                                  id: "configurationComponent",
                                  apps: _vm.apps,
                                  apptoken: _vm.app_token,
                                  show_notification_configuration:
                                    _vm.show_notification_configuration,
                                  nodeValue: _vm.nodeValueForApp
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.isAppAdmin
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "ma-1",
                                  attrs: { sm12: "", md6: "" }
                                },
                                [
                                  _c("userWithAccess", {
                                    attrs: {
                                      id: "userWithAccessComponent",
                                      apptoken: _vm.app_token,
                                      nodeValue: _vm.nodeValueForApp
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.isSuperAdmin
                            ? _c(
                                "v-flex",
                                { staticClass: "ma-1", attrs: { md12: "" } },
                                [
                                  _c("tncconfiguration", {
                                    attrs: {
                                      id: "tncConfigurationComponent",
                                      appid: _vm.selectedappid,
                                      schemaname: _vm.tenantInfo.schema_name,
                                      disabletnc: _vm.disabletnc,
                                      nodeValue: _vm.nodeValueForApp
                                    },
                                    on: {
                                      action: function($event) {
                                        return _vm.enableDisableTNC()
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { staticClass: "ma-1" },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "app-settings-footer rounded-0",
                                  attrs: { flat: "" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.showDisableApplicationButton &&
                                            _vm.isSuperAdmin,
                                          expression:
                                            "showDisableApplicationButton && isSuperAdmin"
                                        }
                                      ],
                                      attrs: {
                                        small: "",
                                        dark: "",
                                        color: "deep-purple darken-3",
                                        id: "disableApplicationBtn"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.confimationAction(
                                            _vm.selectedApp
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Disable the application\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        dark: "",
                                        color: "deep-purple darken-3",
                                        id: "closeSettingsBtn"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeSettings()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            close\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "expiration-message" },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.expirationMessage))
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "confirmationDialog",
        {
          attrs: {
            dialogStatus: _vm.showConfirmationDialog,
            title: "Remove Company",
            width: 570,
            eventName: "confirmationDialogActions",
            actions: _vm.dialogActions
          },
          on: { confirmationDialogActions: _vm.confirmationDialogActions }
        },
        [
          _c("span", [
            _vm._v(
              "\n                Are you sure you want to remove " +
                _vm._s(_vm.rowData.name) +
                " ?\n            "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.notesPopup
        ? _c("NotesComponent", {
            attrs: {
              notesInfo: _vm.notesInfo,
              notesContent: _vm.notesInfo.notes
            },
            on: {
              close: function($event) {
                return _vm.closeNotes()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "scroll",
              rawName: "v-scroll",
              value: _vm.onScroll,
              expression: "onScroll"
            }
          ]
        },
        [
          _vm.displayScroll
            ? _c(
                "v-btn",
                {
                  attrs: {
                    title: "Scroll to top",
                    fixed: "",
                    bottom: "",
                    right: "",
                    small: "",
                    fab: "",
                    color: "white"
                  },
                  on: {
                    click: function($event) {
                      return _vm.scrollToTop()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("arrow_upward")])],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }